/** ---------------------------------------------------------------------------------------
 * --  LICENSE AGREEMENT -- *
 This software is licensed under the following terms:

 * -- GRANT OF LICENSE | RESTRICTIONS -- *
 Subject to the terms and conditions of this license, the copyright holders
 hereby grant you a non-exclusive, non-transferable, revocable license to use,
 copy, modify, and distribute the software.
 You are expressly prohibited from selling or commercially exploiting the software.
 Unauthorized use, reproduction, or distribution of the software, or any part
 thereof, is strictly prohibited.

 * -- AUTHORIZED USERS | INTELLECTUAL PROPERTY -- *
 This license is granted only to the individual or entity to whom the software is
 directly distributed by the copyright holders. Any use by other individuals or
 entities is unauthorized and in violation of this license. The software is
 protected by copyright and other intellectual property laws.
 The copyright holders retain all rights, title, and interest in the software.

 * -- GOVERNING LAW -- *
 This license is governed by and construed in accordance with the laws of Romania.
 Any legal action or proceeding related to this license shall be brought exclusively
 in the courts of Romania.

 [Weddify x Diaphan Stationery] © [2024] All rights reserved.
 -------------------------------------------------------------------------------------- **/

import type {
    BaseQueryFn,
    FetchArgs,
    FetchBaseQueryError
} from "@reduxjs/toolkit/query"
import {apiURL} from '../../utils/AppConfig';
import {
    fetchBaseQuery
} from "@reduxjs/toolkit/query"
import { Mutex } from "async-mutex"
import { toast} from "react-toastify";
import {getErrorMessage} from "../../utils/errorMessages";

const baseUrl = apiURL
const mutex = new Mutex()

const baseQuery = fetchBaseQuery({
    baseUrl
})

const customFetchBase: BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError
> = async (args, api, extraOptions) => {

    await mutex.waitForUnlock()
    let result = await baseQuery(args, api, extraOptions)

    if ((result.error?.data as any)?.message === "Something went wrong!") {
        if (!mutex.isLocked()) {
            const release = await mutex.acquire()

            try {
                const refreshResult = await baseQuery(
                    { url: "auth/refresh" },
                    api,
                    extraOptions
                )

                if (refreshResult.data) {
                    result = await baseQuery(args, api, extraOptions)
                }

            } finally {
                release()
            }
        } else {

            await mutex.waitForUnlock()
            result = await baseQuery(args, api, extraOptions)

        }
    }

    if ((result.error?.data as any)?.errors) {
        if (Array.isArray((result.error as any).data.errors)) {
            (result.error as any).data.errors.forEach((el: any) =>
                toast.error(getErrorMessage(el.code))
            )
        } else {
            toast.error(getErrorMessage((result.error as any).data.code))
        }
    }

    return result
}

export default customFetchBase
